export default "__VITE_ASSET__DC2TZVUd__"